'use client';

import React, { useEffect, useRef } from 'react';

export default function ContactSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.reveal-on-scroll').forEach((el) => {
              (el as HTMLElement).classList.add('is-visible');
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-20 px-6">
      <div className="max-w-container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-6 reveal-on-scroll">
            <div className="mono-label mb-4">Get in Touch</div>
            <h2
              className="font-heading font-semibold text-foreground mb-4"
              style={{ fontSize: 'clamp(1.75rem, 3vw, 2.5rem)', letterSpacing: '-0.025em' }}
            >
              Start with a Planning Assessment
            </h2>
            <p className="text-sm text-muted leading-relaxed font-body mb-6">
              The starting point for most engagements is a planning maturity assessment — a structured
              review of your current SAC Planning architecture, process, and governance. This typically
              takes 2–3 weeks and delivers a findings report with prioritised recommendations.
            </p>
            <p className="text-sm text-muted leading-relaxed font-body mb-8">
              To discuss your SAC Planning program, contact us directly. No sales process — a direct
              conversation with an experienced SAC Planning practitioner.
            </p>
            <a
              href="mailto:free10hours@sacplans.com"
              className="btn-primary text-sm inline-block mb-4"
            >
              free10hours@sacplans.com
            </a>
            <p className="font-mono text-xs text-muted">
              Response within 1 business day · Independent advisory · No vendor affiliation
            </p>
          </div>

          <div className="md:col-span-6 reveal-on-scroll reveal-delay-2">
            <div className="border border-border p-8 bg-secondary" style={{ borderRadius: '4px' }}>
              <div className="mono-label mb-6">What to Include in Your First Email</div>
              <div className="flex flex-col gap-4">
                {[
                  { label: 'Your Role', detail: 'CFO, FP&A Director, SAP Program Manager, Enterprise Architect' },
                  { label: 'Current State', detail: 'Are you evaluating SAC Planning, mid-implementation, or optimising an existing deployment?' },
                  { label: 'Planning Scope', detail: 'Which planning domains — Financial, Sales, Supply Chain, or Enterprise?' },
                  { label: 'Timeline', detail: 'When do you need to have SAC Planning operational?' },
                  { label: 'Specific Challenge', detail: 'What is the primary problem you are trying to solve?' },
                ].map((item) => (
                  <div key={item.label} className="flex gap-4 pb-4 border-b border-border last:border-0 last:pb-0">
                    <span className="font-heading font-semibold text-foreground text-xs w-28 shrink-0 mt-0.5">
                      {item.label}
                    </span>
                    <span className="text-xs text-muted font-body leading-relaxed">{item.detail}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}